
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/defi-development",
      function () {
        return require("private-next-pages/services/defi-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/defi-development"])
      });
    }
  